<template>
    <div class="my-container">
        <!-- Card Principal Integrado -->
        <div class="my-card">
            <!-- Header do DataTable -->
            <div class="my-header">
                <div class="header-left">
                    <h1 class="datatable-title">Visualizar Documento</h1>
                    <span class="records-summary" v-if="loaded">PDF Carregado</span>
                    <span class="records-summary loading" v-else>Carregando...</span>
                </div>
                <div class="header-right">
                    <button @click="$router.go(-1)" class="btn btn-secondary btn-action">
                        <i class="fa fa-arrow-left"></i>
                        <span class="btn-text">Voltar</span>
                    </button>
                    <button @click="getDetail" class="btn btn-primary btn-action">
                        <i class="fa fa-sync-alt"></i>
                        <span class="btn-text">Atualizar</span>
                    </button>
                </div>
            </div>

            <!-- Área de Conteúdo Unificada -->
            <div class="datatable-main-content">
                <!-- Loading State -->
                <div class="datatable-loading" v-if="!loaded">
                    <div class="loading-overlay">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <div class="loading-text">
                            <h4>Carregando documento...</h4>
                            <p>Aguarde enquanto processamos o PDF</p>
                        </div>
                    </div>
                </div>

                <!-- Visualizador de PDF -->
                <div class="pdf-viewer-content" v-else>
                    <div class="pdf-controls">
                        <button @click="downloadPDF" class="btn btn-success btn-action">
                            <i class="fa fa-download"></i>
                            <span class="btn-text">Baixar PDF</span>
                        </button>
                    </div>
                    
                    <iframe 
                        class="pdf-iframe"
                        :src="'data:application/pdf;base64,' + encodeURI(data.base64)"
                        frameborder="0">
                    </iframe>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
            data: {},
            selectedProductName: '',
        };
    },
    computed: {
        positionTime() {
            return moment(this.map[0].PositionTime).format("DD/MM/YYYY H:m:s");
        },
    },
    methods: {
        getDetail() {
            const self = this;
            self.loaded = false;
            let data = self.$route.params.params;

            var api = self.$store.getters.api + "order-fispq/";

            axios
                .post(api, { info: data })
                .then((response) => {
                    self.data = response.data.data;
                    self.loaded = true;
                })
                .catch((error) => {
                    this.$toast.error(
                        "Documento não disponível no momento, favor tente novamente."
                    );
                });
        },
        downloadPDF() {
            let data = this.$route.params.params;
            data = atob(data);
            data = JSON.parse(data);
            console.log(data);
            const blob = this.data.base64 ? this.base64ToBlob(this.data.base64, 'application/pdf') : null;
            if (blob) {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = decodeURIComponent(data.name) +'.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            } else {
                this.$toast.error('Erro ao criar o arquivo para download.');
            }
        },
        base64ToBlob(base64, contentType) {
            const sliceSize = 512;
            const byteCharacters = atob(base64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: contentType });
        }
    },

    mounted() {
        const self = this;
        self.getDetail();
    },
};
</script>

<style scoped>
/* Importando os estilos do BaseTable.vue */

/* DataTable Container */
.my-container {
    padding: 0;
    background: transparent;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    height: 100vh;
}

/* Card Principal */
.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    height: 100vh;
    display: flex;
    flex-direction: column;
}

/* Header do DataTable */
.my-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: 1px solid #e9ecef;
    flex-shrink: 0;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.datatable-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.records-summary {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.records-summary.loading {
    background: rgba(255, 193, 7, 0.3);
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
}

.header-right {
    display: flex;
    gap: 8px;
}

/* Botões de ação */
.btn-action {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:hover {
    background: #5a6fd8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #5a6268;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.btn-success {
    background: #28a745;
    color: white;
}

.btn-success:hover {
    background: #218838;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.btn-text {
    font-size: 13px;
}

/* Container Principal Unificado */
.datatable-main-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 100%;
    position: relative;
}

/* Loading State */
.datatable-loading {
    padding: 60px 24px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
}

.loading-spinner .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text h4 {
    font-size: 18px;
    color: #495057;
    margin: 0 0 8px 0;
}

.loading-text p {
    color: #6c757d;
    margin: 0;
}

/* Visualizador de PDF */
.pdf-viewer-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;
}

.pdf-controls {
    padding: 16px 24px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
}

.pdf-container {
    flex: 1;
    padding: 0;
    overflow: hidden;
    position: relative;
}

.pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        height: 100vh;
    }

    .my-header {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        padding: 16px;
    }

    .header-left {
        width: 100%;
    }

    .header-right {
        width: 100%;
        justify-content: flex-start;
    }

    .pdf-controls {
        padding: 12px 16px;
        justify-content: center;
    }

    .datatable-th,
    .datatable-td {
        padding: 12px;
        font-size: 13px;
    }

    .btn-text {
        display: none;
    }
}

@media (max-width: 576px) {
    .datatable-title {
        font-size: 20px;
    }

    .records-summary {
        font-size: 12px;
        padding: 2px 8px;
    }

    .datatable-loading {
        padding: 40px 16px;
    }

    .btn-action {
        padding: 6px 10px;
        font-size: 12px;
    }

    .pdf-controls {
        padding: 8px 12px;
    }
}

/* Melhorias para o iframe em dispositivos móveis */
@media (max-width: 768px) {
    .pdf-iframe {
        min-height: 500px;
    }
}

/* Estilos para melhor visualização do PDF */
.pdf-container {
    background: #f5f5f5;
}

.pdf-iframe {
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin: 0;
}

/* Loading state para o iframe */
.pdf-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading-shimmer 1.5s infinite;
    z-index: 1;
    pointer-events: none;
}

.pdf-iframe:not([src=""]) ~ .pdf-container::before {
    display: none;
}

@keyframes loading-shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
}
</style>
